import thumb_down from 'assets/like/thumb_down.svg'
import thumb_down_fill from 'assets/like/thumb_down_fill.svg'
import thumb_up from 'assets/like/thumb_up.svg'
import thumb_up_fill from 'assets/like/thumb_up_fill.svg'
import { CircleButton } from 'component/Button/CircleButton'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { DISLIKE, LIKE } from 'type/Inference'

type Props = {
  inference: InferenceStore
}

export const LikeActions = observer(({ inference }: Props) => {
  const { like_mode } = inference
  const Dislike = like_mode === DISLIKE ? thumb_down_fill : thumb_down
  const Like = like_mode === LIKE ? thumb_up_fill : thumb_up

  const onLike = useLatestCallback(() => {
    void controller.likeInference(inference, true)
  })

  const onDislike = useLatestCallback(() => {
    void controller.likeInference(inference, false)
  })

  return <Vertical gap={8}>
    <CircleButton large action={onLike}>
      <Like />
    </CircleButton>
    <CircleButton large action={onDislike}>
      <Dislike />
    </CircleButton>
  </Vertical>
})
